// src/router/agenda.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['operacional_prana', 'coordenador_operacional']


const agendaBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Agenda',
        to: 'Agenda'
    }
]

export default [
    {
        path: '/agenda',
        name: 'Agenda',
        component: () => import('@/views/Agenda/AgendaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Agenda',
            breadcrumb: agendaBreadCrumb
        },
    },
    {
        path: '/agenda/tarefa/nova',
        name: 'TarefaNova',
        component: () => import('@/views/Agenda/NovaTarefaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Processo',
            breadcrumb: [
                ...agendaBreadCrumb,
                {
                    label: 'Novo Processo',
                    to: 'ProcessoNovo'
                }
            ]
        }
    },
    {
        path: '/agenda/tarefa/:id/detalhes',
        name: 'TarefaDetalhes',
        component: () => import('@/views/Agenda/NovaTarefaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Tarefa',
            breadcrumb: [
                ...agendaBreadCrumb,
                {
                    label: 'Nova Tarefa',
                    to: 'TarefaNova'
                }
            ]
        }
    }
];
